<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Przypominamy o trwającym Konkursie na wybór Partnerów do realizacji projektu dronowego w ramach Krajowego Planu Odbudowy (KPO) –
            szczegóły w zakładce KPO/Konkurs.
        </p>
        <p>
            Mamy dla Państwa bardzo dobre informacje - wychodząc naprzeciw zgłaszanym zapytaniom i uwagom dotyczącym trwającego Konkursu
            informujemy, że Polska Agencja Żeglugi Powietrznej dokonała następujących zmian:
        </p>
        <ul>
            <li>
                zmniejszona została minimalna wymagana powierzchnia zgłaszanej lokalizacji przez JST ze 150 km<sup>2</sup> do 100
                km<sup>2</sup>. Kryteria Oceny Konkursu (
                <a
                    href="https://assets.uav.pansa.pl/Za%C5%82%C4%85cznik_nr_4_Kryteria_oceny_Wst%C4%99pnych_Wniosk%C3%B3w.pdf"
                    target="_blank"
                    download
                    class="button-link"
                >
                    Załącznik 4
                </a>
                oraz
                <a
                    href="https://assets.uav.pansa.pl/Za%C5%82%C4%85cznik_nr_5_Kryteria_oceny_Wniosk%C3%B3w.pdf"
                    target="_blank"
                    download
                    class="button-link"
                >
                    Załącznik 5
                </a>
                ) zostały stosownie zmienione.
            </li>
            <li>
                w kategorii "Zaludnienie i inne właściwości danej lokalizacji" usunięto kryterium, które dyskwalifikowało zgłaszany Wniosek
                konkursowy, w przypadku gdy ponad 40% powierzchni zaproponowanej lokalizacji znajdowało się w granicach miasta powyżej 50
                tysięcy mieszkańców.
            </li>
            <li>
                <p>
                    w materiałach do własnych analiz wykonywanych przez Uczestnika zostały udostępnione istniejące struktury przestrzeni
                    powietrznej z podziałem na podgrupy wynikającym z wymagań kryteriów oceny wstępnych wniosków mieszczących się w
                    Załączniku 4 do Regulaminu, co znacząco powinno poprawić proces interpretacji danych przez JST.
                </p>
                <p>
                    Nowy plik do pobrania na stronie konkursowej KPO/Konkurs (<a
                        href="https://assets.uav.pansa.pl/strefy_PL_konkurs_CK.zip"
                        target="_blank"
                        download
                        class="button-link"
                    >
                        Plik - strefy PL - konkurs CK.zip (1MB)
                    </a>
                    ).
                </p>
            </li>
            <li>
                <p>
                    usprawniono działanie modelów do samodzielnego wykonywania analiz zagęszczenia ludności i lokalizacji (materiał zawarty
                    w Załączniku 7), tak aby ich wyniki nawiązywały bezpośrednio do wymagań kryteriów oceny wstępnych wniosków mieszczących
                    się w Załączniku 4 do Regulaminu.
                </p>
                <p>
                    Nowy plik do pobrania na stronie konkursowej KPO/Konkurs (
                    <a
                        href="https://assets.uav.pansa.pl/Plik_do_Zalacznika_7_Zageszczenie_Gmin_Analiza.zip"
                        target="_blank"
                        download
                        class="button-link"
                    >
                        Plik do Instrukcji - Zagęszczenie Gmin Analiza.zip (470 MB)
                    </a>
                    ).
                </p>
            </li>
        </ul>

        <p>
            Szczegółowe informacje o wprowadzonej zmianie do Regulaminu Konkursu –
            <a href="https://assets.uav.pansa.pl/Komunikat_z_dnia_15_04_2025r.pdf" target="_blank" download class="button-link">
                Komunikat z dnia 15.04.2025r.
            </a>
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p class="annotation">* Files are only available in Polish.</p>
        <p>
            We would like to remind you about the ongoing Competition for the selection of Partners for the implementation of the drone
            project under the National Recovery Plan (NRP) – details in the NRP/Competition tab.
        </p>
        <p>
            We have very good news for you - in response to the questions and comments regarding the ongoing Competition, we inform you that
            the Polish Air Navigation Services Agency has made the following changes:
        </p>
        <ul>
            <li>
                The minimum required area of the location submitted by local government units (JST) has been reduced from 150 km<sup>2</sup>
                to 100 km<sup>2</sup>. The Competition Evaluation Criteria (
                <a
                    href="https://assets.uav.pansa.pl/Za%C5%82%C4%85cznik_nr_4_Kryteria_oceny_Wst%C4%99pnych_Wniosk%C3%B3w.pdf"
                    target="_blank"
                    download
                    class="button-link"
                >
                    Załącznik 4
                </a>
                and
                <a
                    href="https://assets.uav.pansa.pl/Za%C5%82%C4%85cznik_nr_5_Kryteria_oceny_Wniosk%C3%B3w.pdf"
                    target="_blank"
                    download
                    class="button-link"
                >
                    Załącznik 5
                </a>
                ) have been accordingly updated.
            </li>
            <li>
                In the category "Population and other characteristics of the location", the criterion disqualifying the submitted
                application if more than 40% of the proposed location area was within the boundaries of a city with over 50,000 inhabitants
                has been removed.
            </li>
            <li>
                <p>
                    Existing airspace structures, divided into subgroups based on the requirements of the preliminary application evaluation
                    criteria included in Załącznik 4 to the Regulations, have been made available for participants' own analyses, which
                    should significantly improve the data interpretation process by local government units (JST).
                </p>
                <p>
                    A new file is available for download on the KPO/Competition page (<a
                        href="https://assets.uav.pansa.pl/strefy_PL_konkurs_CK.zip"
                        target="_blank"
                        download
                        class="button-link"
                    >
                        Plik - strefy PL - konkurs CK.zip (1MB)
                    </a>
                    ).
                </p>
            </li>
            <li>
                <p>
                    The operation of models for independently performing population density and location analyses (material included in
                    Załącznik 7) has been improved so that their results directly correspond to the requirements of the preliminary
                    application evaluation criteria included in Załącznik 4 to the Regulations.
                </p>
                <p>
                    A new file is available for download on the KPO/Competition page (
                    <a
                        href="https://assets.uav.pansa.pl/Plik_do_Zalacznika_7_Zageszczenie_Gmin_Analiza.zip"
                        target="_blank"
                        download
                        class="button-link"
                    >
                        Plik do Instrukcji - Zagęszczenie Gmin Analiza.zip (470 MB)
                    </a>
                    ).
                </p>
            </li>
        </ul>

        <p>
            Detailed information about the introduced change to the Competition Regulations –
            <a href="https://assets.uav.pansa.pl/Komunikat_z_dnia_15_04_2025r.pdf" target="_blank" download class="button-link">
                Komunikat z dnia 15.04.2025r.
            </a>
        </p>
    </ng-container>
</ng-container>
